<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <br />
                        <a href="/info" class="link" v-if="prev_type == 88" style="text-decoration:none;">
                            <i class="bi bi-chevron-left"></i>
                        </a>
                        <a :href="'/card/detail/' + card.id" class="link" @click="confirmSave()" v-else
                            style="text-decoration:none;">
                            <i class="bi bi-chevron-left"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="container-fluid" style="padding-top:70px;">
                <br>

                <div class="row">
                    <div class="col-2">
                        <a @click="nextShowUser(card_message.uid)">
                            <img :src="card_message.icon_url" class="img-fluid" style="border-radius:100px;">
                        </a>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <h5>{{ card_message.name }}&nbsp;<span style="font-size:13px;color:#999;">[{{
                                    card_message.created_at |
                                    loginStatus }}]</span></h5>
                            </div>
                            <div class="col-2 text-end">
                                <div class="dropdown">
                                    <i class="bi bi-three-dots" style="color:#cdcdcd"></i>
                                    <div class="dropdown-content">
                                        <div class="text-center">
                                            <a @click="setPenalty(5, card_message.id)" style="color:#999"
                                                v-if="card_message.uid != user.id">通報</a>
                                            <a @click="rmMessage(card_message.id)" style="color:#999" v-else>削除</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="white-space: pre-line;">{{ card_message.message }}</div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div style="display:flex; padding:5px;flex-wrap: wrap;">
                                    <button v-for="(emoji, e_index) in card_emoji" :key="emoji.id" type="button"
                                        class="btn btn-luna-icon" style="padding:0 8px;"
                                        @click="addEmoji(emoji.emoji, emoji.id, emoji.card_message_id, emoji.card_id, 0, e_index, 1)">
                                        <div style="white-space: nowrap">{{ emoji.emoji }}<span
                                                style="padding-left:2px;font-size:12px;color:#666">{{
                                                    emoji.count
                                                }}</span></div>
                                    </button>
                                    <div style="">
                                        <div :ref="'tooltipEmojiMainRef' + card_message.id"
                                            class="emoji_picker picker_box" style="margin-top:2rem;">
                                            <div class="picker_container"
                                                :ref="'tooltipEmojiMainPickerRef' + card_message.id">
                                                <div class="category" v-for="category in categories"
                                                    :key="`category_${category}`">
                                                    <span>{{ category }}</span>
                                                    <div class="emojis_container">
                                                        <button
                                                            @click="cmid = card_message.id, message_index = 0, handleEmojiClick($event, emoji, index, category, card_message.id, 1)"
                                                            v-for="(emoji, index) in category_emojis(category)"
                                                            :key="`emoji_${index}`">
                                                            {{ emoji }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            @click="tooltipEmojis(card_message.id, 'tooltipEmojiMainRef' + card_message.id, 'tooltipEmojiMainPickerRef' + card_message.id, 1)"
                                            type="button" class="btn btn-luna-icon" style="padding:0 8px;">
                                            <img src="/images/emoji_add.svg" alt="icon"
                                                style="width:16px;height:16px;margin-top:-2px;" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 px-0 text-end">
                                <div style="padding-right:5px;">
                                    <button type="button" class="btn btn-luna-d"
                                        style="color:#6b4eff;font-size: 12px; padding: 8px 12px;background:#f2f2f2;border:0;"
                                        @click="setTweets(card_message.message)">
                                        <TwitterXIcon /> 共有
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col px-0">
                        <hr style="background-color: #f2f2f2;">
                    </div>
                </div>
                <div>
                    <div class="row"
                        v-if="btn_type != CARD_REGISTRATION_STATE.MEMBER_REGISTERABLE && btn_type != CARD_REGISTRATION_STATE.OWNER_REGISTERABLE">
                        <div class="col">
                            <div><b>返信</b></div>
                            <div id="innerMessage" contenteditable="true" class="luna-form-control" @click="setCaret()"
                                placeholder="ここからコメントができます！" style="height:100px;overflow:auto;" v-text="inner_message"
                                @input="sync">

                            </div>
                        </div>
                    </div>
                    <div class="row"
                        v-if="btn_type != CARD_REGISTRATION_STATE.MEMBER_REGISTERABLE && btn_type != CARD_REGISTRATION_STATE.OWNER_REGISTERABLE"
                        style="padding-bottom:20px;border-bottom: 1px solid #f2f2f2;">
                        <div class="col text-end" style="padding-top:8px;">
                            <button v-if="message != ''" type="button" class="btn btn-luna"
                                style="padding: 2px 14px 5px 16px;" @click="setMessage()">
                                <svg style="height:16px;width:16px;fill:#fff;">
                                    <use xlink:href="/images/icon/dm_send.svg#dm_send"></use>
                                </svg>
                            </button>
                            <button v-else type="button" class="btn btn-luna-d" style="padding: 2px 14px 5px 16px;">
                                <svg style="height:16px;width:16px;fill:#fff;">
                                    <use xlink:href="/images/icon/dm_send.svg#dm_send"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <br>
                    <div v-for="(user_msg, index) in user_list" :key="user_msg.id"
                        style="padding-left:20px;padding-bottom:20px;padding-top:20px;border-bottom: 1px solid #f2f2f2;">
                        <div class="row">
                            <div class="col-2">
                                <a @click="nextShowUser(user_msg.uid)">
                                    <img :src="user_msg.icon_url" class="img-fluid" style="border-radius:100px;">
                                </a>
                            </div>
                            <div class="col">
                                <div class="row">
                                    <div class="col">
                                        <div><b>{{ user_msg.name }}</b><span style="font-size:13px;color:#999;">・{{
                                            user_msg.created_at |
                                            loginStatus }}</span></div>
                                    </div>
                                    <div class="col-2 text-end">
                                        <div class="dropdown">
                                            <i class="bi bi-three-dots" style="color:#cdcdcd"></i>
                                            <div class="dropdown-content">
                                                <div class="text-center">
                                                    <a @click="setPenalty(6, user_msg.id)" style="color:#999"
                                                        v-if="user_msg.uid != user.id">通報</a>
                                                    <a @click="rmMessageDetail(user_msg.id)" style="color:#999"
                                                        v-else>削除</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <!-- メッセージ表示: v-html を使わず、テキスト補間（自動エスケープ）で XSS を防止。
                                         @メンション部分だけ紫色スタイルの span で描画する。
                                         parseMessage() がメッセージを「通常テキスト」と「@メンション」に分割する。 -->
                                    <div class="col" style="white-space: pre-line;">
                                        <template v-for="(seg, segIdx) in parseMessage(user_msg.message)">
                                            <span v-if="seg.mention" :key="'m-' + index + '-' + segIdx"
                                                style="color:#6B4EFF;">{{ seg.text }}</span>
                                            <span v-else :key="'t-' + index + '-' + segIdx">{{ seg.text
                                            }}</span>
                                        </template>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div style="display:flex; padding:5px;flex-wrap: wrap;">
                                            <button v-for="(emoji, e_index) in user_msg.emojis" :key="emoji.id"
                                                type="button" class="btn btn-luna-icon" style="padding:0 8px;"
                                                @click="addEmoji(emoji.emoji, emoji.id, emoji.card_message_id, emoji.card_id, index, e_index, 2)">
                                                <div style="white-space: nowrap">{{ emoji.emoji }}<span
                                                        style="padding-left:2px;font-size:12px;color:#666">{{
                                                            emoji.count
                                                        }}</span></div>
                                            </button>
                                            <div style="">
                                                <div :ref="'tooltipEmojiDetailRef' + user_msg.id"
                                                    class="emoji_picker picker_box">
                                                    <div class="picker_container"
                                                        :ref="'tooltipEmojiDetailPickerRef' + user_msg.id">
                                                        <div class="category" v-for="category in categories"
                                                            :key="`category_${category}`">
                                                            <span>{{ category }}</span>
                                                            <div class="emojis_container">
                                                                <button
                                                                    @click="handleEmojiClick($event, emoji, index, category, user_msg.id, 2)"
                                                                    v-for="(emoji, index) in category_emojis(category)"
                                                                    :key="`emoji_${index}`">
                                                                    {{ emoji }}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button
                                                    @click="cmid = user_msg.id, message_index = index, tooltipEmojis(user_msg.id, 'tooltipEmojiDetailRef' + user_msg.id, 'tooltipEmojiDetailPickerRef' + user_msg.id, 2)"
                                                    type="button" class="btn btn-luna-icon" style="padding:0 8px;">
                                                    <img src="/images/emoji_add.svg" alt="icon"
                                                        style="width:16px;height:16px;margin-top:-2px;" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3 px-0 text-end">
                                        <div style="padding-right:5px;">
                                            <button type="button" class="btn btn-luna-d"
                                                style="color:#6b4eff;font-size: 12px; padding: 8px 12px;background:#f2f2f2;border:0;"
                                                @click="mention = user_msg.luna_account, mention_name = user_msg.name, is_page_mention = true, setMentionInnerMessage(user_msg.luna_account)">
                                                <svg style="height:12px;width:12px;fill:#6b4eff;margin-top: -3px;">
                                                    <use xlink:href="/images/icon/dm_send.svg#dm_send"></use>
                                                </svg>&nbsp;返信
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="count != 0">
                        <div class="col">
                            <div class="text-center" style="padding-top: 40px; padding-bottom: 20px; color: #6c7072"
                                v-if="is_page && count != 0">
                                <a @click="getMessageMore()">もっとみる</a>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="is_load_under">
                        <div class="col text-center">
                            <div class="spinner-grow" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <br>
            </div>
        </div>
        <div style="z-index: 999999;background-color: rgba(0, 0, 0, 0.49);position: fixed;top:0;left:0;width: 100%;height: 100%;"
            id="good_message_page" v-show="is_page_mention">
            <div class="page-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col text-center">
                                    <div style="padding: 0 10px; font-size:20px;color:#fff;margin-top:80px;"
                                        @click="is_page_mention = false">
                                        <svg style="height:16px;width:16px;fill:#fff;margin-bottom: 3px;">
                                            <use xlink:href="/images/x.svg#x"></use>
                                        </svg>&nbsp;閉じる
                                    </div>
                                </div>
                            </div>
                            <div class="card border-light" style="margin-top:10px;">
                                <div class="card-body">
                                    <div class="text-start">
                                        <b><span>{{ mention_name | omittedText }}さんに返信</span></b>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div id="mentionInnerMessage" contenteditable="true"
                                                class="luna-form-control" placeholder="ここからコメントができます！"
                                                style="height:100px;overflow:auto;" v-text="mention_inner_message"
                                                @input="syncInner">

                                            </div>
                                            <p class="error-text" id="error-good_message" v-if="!is_set">
                                                文字数がオーバーしています（最大140文字）</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col text-end" style="padding-top:8px;">
                                            <button v-if="mention_message != '' && is_set" type="button"
                                                class="btn btn-luna" style="padding: 2px 14px 5px 16px;"
                                                @click="message = mention_message, setMessage()">
                                                <svg style="height:16px;width:16px;fill:#fff;">
                                                    <use xlink:href="/images/icon/dm_send.svg#dm_send"></use>
                                                </svg>
                                            </button>
                                            <button v-else type="button" class="btn btn-luna-d"
                                                style="padding: 2px 14px 5px 16px;">
                                                <svg style="height:16px;width:16px;fill:#fff;">
                                                    <use xlink:href="/images/icon/dm_send.svg#dm_send"></use>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { clearPageStorage } from '../../event-log/clearPageStorage';
import EmojiData from '../../.././json/emojis-data.json';
import { CARD_REGISTRATION_STATE } from '../../constants/cardRegistrationState';

export default {
    data() {
        return {
            count: 0,
            user: [],
            card: [],
            card_message: [],
            card_emoji: [],
            tab: 1,
            message: "",
            inner_message: "",
            user_list: [],
            members: [],
            btn_type: 0,
            CARD_REGISTRATION_STATE,
            is_load: true,
            is_load_under: false,
            is_page: true,
            emojis: [],
            cmid: "",
            message_index: 0,
            emoji_index: 0,
            page: 1,
            windowSize: 0,
            showTooltip: false,
            tooltips: [],
            age_list: [],
            area_list: [],
            sex_list: [],
            member_count: 0,
            is_member_page: true,
            is_member_load_under: false,
            member_page: 1,
            first_view: true,
            tweet: "",
            mention: "",
            mention_name: "",
            is_page_mention: false,
            mention_message: "",
            mention_inner_message: "",
            is_set: true,
            prev_type: 0,
        };
    },
    mouted: function () {
        window.addEventListener("scroll", this.handleScroll)
    },
    methods: {
        setCaret() {
            /*             const innerMessage = document.querySelector('#innerMessage')

              const selection = window.getSelection()
              const range = document.createRange()
              const offset = innerMessage.innerText.length
              range.setStart(innerMessage.firstChild, offset)
              range.setEnd(innerMessage.firstChild, offset)
              selection.removeAllRanges()
              selection.addRange(range) */

        },
        sync(e) {
            this.message = e.target.innerHTML
        },
        syncInner(e) {
            this.mention_message = e.target.innerHTML
        },
        setMentionInnerMessage(luna_account) {
            $('#mentionInnerMessage').html("<span contenteditable='false' style='color:#6B4EFF;'>@" + luna_account + "&nbsp;</span>")
        },
        async regCardMember() {
            if (this.user.card_limit_count > 0) {
                await axios.get("/api/card/member/reg/" + this.$route.params['cid'])
                    .then(
                        (response) => {
                            const isOwner = Number(this.card.user_id) === Number(this.user.id)
                            this.btn_type = isOwner ? CARD_REGISTRATION_STATE.OWNER_REGISTERED : CARD_REGISTRATION_STATE.MEMBER_REGISTERED
                            this.user.card_limit_count = response.data.limit_count
                        }
                    )
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("カードの登録に失敗しました")
                        }
                    })
            }
            else {
                if (this.user.is_limited) {
                    alert('11枚以上の登録は有料機能です。多くの登録をすることで、マッチング率が10倍になります。')
                }
                else {
                    alert('登録最大上限に達しました。新しく登録する場合は既に選んでるカードを外してください。')
                }
                return
            }
        },
        async rmCardMember() {
            await axios.get("/api/card/member/rm/" + this.$route.params['cid'])
                .then(
                    (response) => {
                        const isOwner = Number(this.card.user_id) === Number(this.user.id)
                        this.btn_type = isOwner ? CARD_REGISTRATION_STATE.OWNER_REGISTERABLE : CARD_REGISTRATION_STATE.MEMBER_REGISTERABLE
                        this.user.card_limit_count = response.data.limit_count
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの登録解除に失敗しました")
                    }
                })
        },
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    () => {
                        this.fetchUsers()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/get/me")
                .then((response) => {
                    this.user = response.data.user
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async getMessage() {
            await axios.get("/api/card/message/detail/get/" + this.$route.params['cmid'])
                .then((response) => {
                    this.card = response.data.card
                    this.card_message = response.data.card_message
                    this.card_emoji = response.data.card_emoji
                    this.user_list = response.data.messages.data
                    this.count = response.data.count
                    this.tweet = response.data.tweet

                    $('#innerMessage').html("<span contenteditable='false' style='color:#6B4EFF;'>@" + this.card_message.luna_account + "&nbsp;</span>&nbsp;")
                    //$('#innerMessage').focus()

                    this.mention = this.card_message.luna_account

                    if (this.count != 0) {
                        this.first_view = false
                    }

                    let c = []
                    this.user_list.forEach(function (message) {
                        c[message.id] = false
                    })

                    this.tooltips = c
                    //this.tooltips[0] = false

                    if (this.count <= 20) {
                        this.is_page = false
                    }

                    this.getEmoji(this.card_message.id)
                })
                .catch(function (error) {
                    if (error.response && error.response.status == 401) {
                        // window.location.href = "/auth?logout=true"
                    }
                    else {
                        //window.location.href = "/error"
                    }
                })
        },
        async getMessageMore() {
            this.is_load_under = true
            const prevPage = this.page
            this.page++

            await axios.get("/api/card/message/detail/get/" + this.$route.params['cmid'] + "?page=" + this.page)
                .then((response) => {
                    this.user_list.push.apply(this.user_list, response.data.messages.data)

                    let c = this.tooltips
                    response.data.messages.data.forEach(function (message) {
                        c[message.id] = false
                    })

                    this.tooltips = c

                    if (response.data.messages.data.length == 0) {
                        this.is_page = false
                    }
                    this.getEmoji(this.card.id)

                    if (response.data.messages.data.length == 0) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("メッセージの取得に失敗しました")
                    }
                    this.page = prevPage
                    this.is_page = false
                }).finally(() => {
                    this.is_load_under = false
                })
        },
        async getEmoji(cmid) {
            await axios.get("/api/card/emoji/detail/get/" + cmid)
                .then((response) => {
                    let list = this.emojis
                    let keys = Object.keys(list)

                    response.data.emojis.forEach(function (e) {
                        keys = Object.keys(list)
                        var key = keys.find(function (value) {
                            return value == e.card_message_detail_id
                        })

                        if (key === void 0) {
                            list[e.card_message_detail_id] = []
                        }

                        list[e.card_message_detail_id].push({
                            "id": e.id,
                            "emoji": e.emoji,
                            "count": e.count
                        })
                    })

                    this.emojis = list
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("絵文字の取得に失敗しました")
                    }
                })
        },
        async setMessage() {
            await axios.post("/api/card/message/detail/set", {
                message: this.message,
                mention: this.mention,
                card_message_id: this.card_message.id,
            })
                .then((response) => {
                    this.message = ""
                    this.mention_message = ""
                    this.mention = ""
                    this.is_page_mention = false
                    this.getMessage()
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("メッセージの送信に失敗しました")
                    }
                })
        },
        async handleEmojiClick(e, emoji, i, c, id, type) {
            if (type == 1) {
                e.preventDefault();
                this.$emit('emoji_click', emoji);

                await axios.post("/api/card/emoji/set", {
                    card_message_id: this.cmid,
                    emoji: emoji,
                    card_id: this.card.id,
                    category: c,
                    emoji_no: i,
                    emoji_id: "",
                })
                    .then((response) => {
                        this.card_emoji = response.data.emojis

                        this.tooltipEmojis(id, 'tooltipEmojiMainRef' + id, 'tooltipEmojiMainPickerRef' + id, 1)
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
            else {
                e.preventDefault();
                this.$emit('emoji_click', emoji);

                console.log(this.cmid)

                await axios.post("/api/card/emoji/detail/set", {
                    card_message_detail_id: this.cmid,
                    emoji: emoji,
                    card_id: this.card.id,
                    category: c,
                    emoji_no: i,
                    emoji_id: "",
                })
                    .then((response) => {
                        this.user_list[this.message_index].emojis = response.data.emojis

                        this.tooltipEmojis(id, 'tooltipEmojiDetailRef' + id, 'tooltipEmojiDetailPickerRef' + id, 2)
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        },
        async addEmoji(emoji, emoji_id, card_message_id, card_id, message_index, emoji_index, type) {
            if (type == 1) {
                await axios.post("/api/card/emoji/set", {
                    card_message_id: card_message_id,
                    emoji: emoji,
                    card_id: this.card.id,
                    category: "",
                    emoji_no: "",
                    emoji_id: emoji_id,
                })
                    .then((response) => {
                        this.card_emoji[emoji_index].count = response.data.count
                        this.showTooltip = false

                        if (response.data.count == 0) {
                            this.card_emoji.splice(emoji_index, 1)
                        }
                    })
                    .catch(function (error) {
                    })
            }
            else {
                await axios.post("/api/card/emoji/detail/set", {
                    card_message_detail_id: card_message_id,
                    emoji: emoji,
                    card_id: this.card.id,
                    category: "",
                    emoji_no: "",
                    emoji_id: emoji_id,
                })
                    .then((response) => {
                        this.user_list[message_index].emojis[emoji_index].count = response.data.count
                        this.showTooltip = false

                        if (response.data.count == 0) {
                            this.user_list[message_index].emojis.splice(emoji_index, 1)
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        },
        tooltipEmojis(n, e, p, type) {
            var re = this.$refs[e][0]
            var pi = this.$refs[p][0]

            if (type == 1) {
                re = this.$refs[e]
                pi = this.$refs[p]
            }

            if (this.tooltips[n]) {
                re.style.height = '0rem'
                pi.style.padding = '0rem'
                re.style.border = '0px'
            }
            else {
                const rect = re.getBoundingClientRect()
                if (window.innerWidth < rect.right) {
                    re.style.right = '20px'
                }
                pi.style.padding = '1rem'
                re.style.height = '20rem'
                re.style.border = '1px solid #ddd'

            }
            this.tooltips[n] = !this.tooltips[n]
        },
        async handleScroll() {
            if (this.is_load_under) {
                return
            }
            let bottom = document.body.scrollHeight - document.body.clientHeight

            this.scrollY = window.scrollY
            let p = Math.abs(bottom - this.scrollY)
            if (this.tab == 1) {
                if (p < 1 && this.is_page) {
                    this.getMessageMore()
                }
            }
            else {
                if (p < 1 && this.is_member_page) {
                    this.fetchMemberMore()
                }
            }
        },
        async setPenalty(status, id) {
            await axios.post("/api/card/penalty/set", {
                id: id,
                status: status
            })
                .then((response) => {
                    alert("通報しました。");
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("通報に失敗しました")
                    }
                })
        },
        setTweets(msg) {
            window.open(this.tweet + msg.substring(0, 49) + '%0a&hashtags=LunaSM')
        },
        nextShowUser(uid) {
            window.location.href = "/user/show/" + uid + "?profile_source=card_message_detail"
        },
        confirmSave() {
            clearPageStorage()
        },
        async rmMessage(cid) {
            await axios.get("/api/card/message/rm/" + cid)
                .then(
                    (response) => {
                        this.getMessage()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("メッセージの削除に失敗しました")
                    }
                })
        },
        async rmMessageDetail(cmid) {
            await axios.get("/api/card/message/detail/rm/" + cmid)
                .then(
                    (response) => {
                        this.getMessage()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("メッセージの削除に失敗しました")
                    }
                })
        },
        /**
         * メッセージ文字列を「通常テキスト」と「@メンション」のセグメント配列に分割する。
         *
         * 仕組み:
         *   1. innerHTML → textContent で HTML タグを除去し、プレーンテキストを得る
         *      - contenteditable 経由で保存された HTML（メンション span 等）からテキストだけ抽出
         *      - これにより任意の HTML タグが無害化される（XSS 防止）
         *   2. 正規表現で @メンション 部分を検出し、テキストを交互に分割
         *   3. 各セグメントに mention フラグを付与 → テンプレート側で紫色スタイルを適用
         *
         * 戻り値の例: [{ text: '', mention: false }, { text: '@user1', mention: true }, ...]
         */
        parseMessage(value) {
            if (!value) return []

            // HTML タグを除去してプレーンテキストを抽出
            // contenteditable は改行を <br> や <div> で保存するため、
            // textContent 抽出前に改行文字へ変換しておく
            const html = value
                .replace(/<br\s*\/?>/gi, '\n')
                .replace(/<\/div>/gi, '\n')
                .replace(/<\/p>/gi, '\n')
            const tmp = document.createElement('div')
            tmp.innerHTML = html
            const text = tmp.textContent || tmp.innerText || ''

            // @メンション を検出してセグメントに分割
            const segments = []
            const regex = /@\S+/g
            let lastIndex = 0
            let match

            // TODO: メンションに色付けしても意味がないので、移行時に削除することも検討して良いかも
            while ((match = regex.exec(text)) !== null) {
                // メンションの前にある通常テキスト
                if (match.index > lastIndex) {
                    segments.push({ text: text.slice(lastIndex, match.index), mention: false })
                }
                // メンション部分
                segments.push({ text: match[0], mention: true })
                lastIndex = match.index + match[0].length
            }

            // 残りの通常テキスト
            if (lastIndex < text.length) {
                segments.push({ text: text.slice(lastIndex), mention: false })
            }

            return segments
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            if (localStorage.getItem('prev_type') !== null) {
                                this.prev_type = localStorage.getItem('prev_type')

                                localStorage.removeItem('prev_type')
                            }

                            this.windowSize = window.innerWidth
                            this.init()
                            this.getMessage()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                if (localStorage.getItem('prev_type') !== null) {
                    this.prev_type = localStorage.getItem('prev_type')

                    localStorage.removeItem('prev_type')
                }

                this.windowSize = window.innerWidth
                this.init()
                this.getMessage()
            }
        }
        else {
            if (localStorage.getItem('prev_type') !== null) {
                this.prev_type = localStorage.getItem('prev_type')

                localStorage.removeItem('prev_type')
            }

            this.windowSize = window.innerWidth
            this.init()
            this.getMessage()
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll)
    },
    props:
    {
        show_arrow:
        {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed:
    {
        categories() {
            return Object.keys(EmojiData);
        },
        category_emojis: () => (category) => {
            return Object.values(EmojiData[category]);
        }
    },
    filters: {
        loginStatus(login_at) {
            let status = "数秒前"

            let dt = new Date()
            let lg = new Date(login_at)

            lg.setHours(lg.getHours() + 9)

            var diff = dt.getTime() - lg.getTime()
            //分
            var minutes = Math.floor(diff / (60 * 1000))
            //時
            var hour = Math.floor(diff / (60 * 60 * 1000))
            //日
            var day = Math.floor(diff / (1000 * 60 * 60 * 24))

            if (day == 0 && hour == 0 && minutes > 0) {
                status = minutes + "分前"
            } else if (day == 0 && hour > 0) {
                status = hour + "時間前"
            } else if (day > 0 && day < 31) {
                status = day + "日前"
            } else if (day > 30) {
                status = "30日以上前"
            }

            return status
        },
        lastLoginStatus(login_at) {
            let status = "数秒前"

            let dt = new Date()
            let lg = new Date(login_at)

            //lg.setHours(lg.getHours() + 9)

            var diff = dt.getTime() - lg.getTime()
            //分
            var minutes = Math.floor(diff / (60 * 1000))
            //時
            var hour = Math.floor(diff / (60 * 60 * 1000))
            //日
            var day = Math.floor(diff / (1000 * 60 * 60 * 24))

            if (day == 0 && hour == 0 && minutes > 0) {
                status = minutes + "分前"
            } else if (day == 0 && hour > 0) {
                status = hour + "時間前"
            } else if (day > 0 && day < 31) {
                status = day + "日前"
            } else if (day > 30) {
                status = "30日以上前"
            }

            return status
        },
        omittedText(text) {
            if (text == null) {
                return ""
            } else {
                return text.length > 10 ? text.slice(0, 10) + "…" : text
            }
        },
    },
    watch: {
        mention_message: function (u) {
            let msg = u.replace(/(<([^>]+)>)/gi, '')

            this.message_count = msg.length
            if (msg.length > 140) {
                this.is_set = false
            } else {
                this.is_set = true
            }
        },
    },
};
</script>
<style scoped>
.luna-footer-card-menu {
    position: fixed;
    bottom: 0;
    width: 538px;
    height: 80px;
    background-color: #ffffff86;
    padding-top: 15px;
    z-index: 99999;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }

    .luna-footer-card-menu {
        width: 100%;
    }
}

.emoji_picker {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 20rem;
    height: 20rem;
    max-width: 100%;
}

.picker_container {
    border-radius: 0.5rem;
    background: white;
}

.picker_container {
    position: relative;
    overflow: auto;
    z-index: 1;
}

.category {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    color: rgb(169, 169, 169);
}

.emojis_container {
    display: flex;
    flex-wrap: wrap;
}

.category button {
    margin: 0.5rem;
    margin-left: 0;
    background: inherit;
    border: none;
    font-size: 1rem;
    padding: 0;
}

.picker_box {
    width: 20rem;
    height: 0rem;
    border: 0px;
    z-index: 9999;
    position: absolute;
    background-color: #fff;
    margin-top: -20rem;
    border-radius: 5px;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 80px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 12px 16px;
    z-index: 1;
    right: 0;
}

.dropdown:hover .dropdown-content {
    display: block;
}

.luna-card-active {
    border-bottom: 2px solid #6B4EFF;
    color: #6B4EFF;
    font-size: 14px;
}

.luna-card-non-active {
    border-bottom: 1px solid #CDCDCD;
    color: #CDCDCD;
    font-size: 14px;
}

[contenteditable=true]:empty:before {
    content: attr(placeholder);
    pointer-events: none;
    display: block;
    /* For Firefox */
    color: #CDCDCD;
}
</style>
